import { render, staticRenderFns } from "./v2_mobile.vue?vue&type=template&id=2e7471eb&"
import script from "./v2_mobile.vue?vue&type=script&lang=js&"
export * from "./v2_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports